export default __webpack_public_path__ + "static/ChangeModelFaces-362d6bdac1dfcb64125a875725c7eecd.mp4";